import React, { useState } from 'react'
import "./simpleBanner.css"
import Img from "../../assets/images/payrollBanner.jpeg"
import FormModal from '../formModal/FormModal';

const SimpleBanner = ({ isRtl }) => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const content = isRtl
        ? {
            heading: "منصة متكاملة لإدارة الموارد البشرية و الرواتب في دولة الإمارات العربية المتحدة",
            paragraph1: "تمكنك منصة إتش آر باس من تنظيم إدارة الموارد البشرية و الرواتب، بدايةً من التحاق الموظفين، حتى نهـاية الخـدمة، و تقدم لكم  حلولاً متكاملة من التنظيم و الالتزام بالقوانين والاشتراطات للجهات الحكومية المعنية في الدولة.",
            buttonText: "اطلب عرض تجريبي",
        }
        : {
            heading: "ALL-IN-ONE HR system for managing employee affairs in the United Arab Emirates",
            paragraph1:
                "HR PASS is a comprehensive platform that enables you to organize the company’s files, manage employee affairs, and calculate salaries following the laws and requirements of the Ministry of Human Resources and Emiratisation in the country.",
            buttonText: "GET A FREE DEMO",
        };
    return (
        <section className={`SimpleBannerSection ${isRtl ? "rtl" : ""}`}>
            <div className="">
                <div className="row align-items-stretch">
                    <div className="col-lg-6 col-md-6 col-12" data-aos-easing="ease-in-out" data-aos="fade-right">
                        <div className="banner-content">
                            <h1>{content.heading}</h1>
                            <p>{content.paragraph1}</p>
                            <p>{content.paragraph2}</p>

                            {/* <button type="button" className="darkBrownBtn" onClick={handleShow}>
                                {content.buttonText}
                            </button> */}
                            <FormModal isRtl={isRtl} />
                        </div>
                    </div>
                    {/* <div className="col-lg-2 d-none d-lg-flex">

                    </div> */}
                    <div className="col-lg-6 col-md-6 col-12" data-aos-easing="ease-in-out" data-aos="fade-left">
                        <img src={Img} className='abBannerImg' alt="" style={{ width: "100%" }} />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SimpleBanner